import { useContext } from 'react'
//
import {PermissionsContext} from '../contexts/PermissionsContexts'

// ----------------------------------------------------------------------

const usePermissions = () => {
  const context = useContext(PermissionsContext)

  if (!context) throw new Error('Permissions context must be use inside PermissionsProvider')

  return context
}

export default usePermissions
